import styled from 'styled-components';

export const FullScreenBox = styled.main`
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  z-index: 10;
`;

export const LogoWrapper = styled.section`
  width: 15rem;
  height: 1.75rem;
  position: relative;

  svg {
    width: 15rem;
    height: auto;

    &.back-logo {
      fill: ${({ theme }) => theme.colors.border.gray};
    }

    &.front-logo {
      fill: ${({ theme }) => theme.colors.secondary.health_green};
    }
  }

  div {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    overflow: hidden;
    animation: slideOut 3s ease-out forwards;

    @keyframes slideOut {
      from {
        width: 0%;
      }

      to {
        width: 100%;
      }
    }
  }
`;

export const TextWrapper = styled.div`
  width: 15rem;
  height: 1.75rem;
  overflow: hidden;
  margin-top: 2.5rem;
`;

export const TextContent = styled.div`
  position: relative;

  p {
    line-height: 1.5rem;
    position: absolute;
    text-align: center;
    width: 100%;

    :nth-child(1) {
      animation: showOut 300ms ease-out 700ms forwards;
    }
    :nth-child(2) {
      top: 1.5rem;
      animation: showIn 300ms ease-out 700ms forwards, showOut 300ms ease-out 1.7s forwards;
    }
    :nth-child(3) {
      top: 1.5rem;
      animation: showIn 300ms ease-out 1.7s forwards;
    }

    @keyframes showIn {
      from {
        top: 1.5rem;
      }

      to {
        top: 0rem;
      }
    }

    @keyframes showOut {
      from {
        top: 0;
      }

      to {
        top: -1.5rem;
      }
    }
  }
`;
